// import React from "react";
// import styles from "./PcosRiskAssessment.module.css";

// const PcosRiskCheck = ({ onNext }) => {
//     return (
//         <>
//             <div className={styles.header}>
//                 <div className={styles.step}>1</div>
//                 <h2>PCOS Risk Check Intro</h2>
//             </div>
//             {/* Mobile Frame */}
//             <div className={styles.mobileFrame}>
//                 {/* Status */}
//                 <div className={styles.content}>
//                     <div className={styles.riskCard}>
//                         <div>
//                             {/* heading */}
//                             <h1 className={styles.title}>
//                                 PCOS Risk
//                                 <br />
//                                 Check
//                             </h1>
//                             <p className={styles.description}>
//                                 A quick screening to understand your risk for
//                                 Polycystic Ovary Syndrome (PCOS).
//                             </p>

//                             {/* features */}
//                             <div className={styles.features}>

//                                 <div className={styles.featureItem}>
//                                     <div className={styles.iconBox}>
//                                         <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                                             <circle
//                                                 cx="12"
//                                                 cy="12"
//                                                 r="9"
//                                                 stroke="#F54291"
//                                                 strokeWidth="2"
//                                             />
//                                             <path
//                                                 d="M12 7V12L15 14"
//                                                 stroke="#F54291"
//                                                 strokeWidth="2"
//                                                 strokeLinecap="round"
//                                             />
//                                         </svg>
//                                     </div>

//                                     <p>Takes less than 7 minutes</p>
//                                 </div>

//                                 <div className={styles.featureItem}>
//                                     <div className={styles.iconBox}>
//                                         <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                                             <rect
//                                                 x="5"
//                                                 y="10"
//                                                 width="14"
//                                                 height="10"
//                                                 rx="2"
//                                                 stroke="#F54291"
//                                                 strokeWidth="2"
//                                             />
//                                             <path
//                                                 d="M8 10V7C8 5 9.5 4 12 4C14.5 4 16 5 16 7V10"
//                                                 stroke="#F54291"
//                                                 strokeWidth="2"
//                                             />
//                                         </svg>
//                                     </div>

//                                     <p>Private & confidential</p>
//                                 </div>

//                                 <div className={styles.featureItem}>
//                                     <div className={styles.iconBox}>
//                                         <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                                             <path
//                                                 d="M12 4L14.5 9L20 10L16 14L17 20L12 17L7 20L8 14L4 10L9.5 9L12 4Z"
//                                                 stroke="#F54291"
//                                                 strokeWidth="2"
//                                                 strokeLinejoin="round"
//                                             />
//                                         </svg>
//                                     </div>

//                                     <p>Not a medical diagnosis</p>
//                                 </div>
//                             </div>

//                         </div>
//                         <div className={styles.imgWrapper}>
//                             <img src="/images/lifeStageImage.png" alt="woman" className={styles.lifeStageImg} />
//                         </div>
//                     </div>

//                     {/* bottom card */}
//                     <div className={styles.bottomCard}>
//                             <button className={`btn-primary `} onClick={onNext}>
//                             Start screening
//                         </button>
//                     </div>

//                 </div>
//             </div>
//         </>
//     );
// };

// export default PcosRiskCheck;
// WelcomeScreen.jsx — PCOS Risk Check Intro Screen
import React from 'react';
// import styles from './PCOSScreens.module.css';
import styles from './PcosRiskAssessment.module.css'

const WelcomeScreenPCOS = ({ onNext, onBack }) => {
  return (
    <div className={styles.welcomeWrapper}>

      {/* ── Top bar ── */}
      <div className={styles.topBar}>
        <div className={styles.logo}>
          <div className={styles.logo}>
          <img src='/Home/FemCareLogo.svg' alt='femcare' style={{height:"32px"}}/>
        </div>
        </div>
        {onBack && (
          <button className={styles.backBtn} onClick={onBack}>Back</button>
        )}
      </div>

      {/* ── Step badge ── */}
      <div className={styles.stepBadge}>
        <span className={styles.stepDot}>1</span>
        <span className={styles.stepBadgeText}>PCOS Risk Check Intro</span>
      </div>

      {/* ── Main content ── */}
      <div className={styles.welcomeContent}>

        {/* Left column */}
        <div className={styles.welcomeLeft}>
          <h1 className={styles.welcomeTitle}>PCOS Risk Check</h1>
          <p className={styles.welcomeDesc}>
            A quick screening to understand your risk for Polycystic Ovary Syndrome (PCOS).
          </p>

          <ul className={styles.featureList}>
            <li className={styles.featureItem}>
              <span className={styles.featureIcon}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              </span>
              <span>Takes less than 7 minutes</span>
            </li>
            <li className={styles.featureItem}>
              <span className={styles.featureIcon}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </span>
              <span>Private &amp; confidential</span>
            </li>
            <li className={styles.featureItem}>
              <span className={styles.featureIcon}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
              </span>
              <span>Not a medical diagnosis</span>
            </li>
          </ul>

          {/* Privacy note */}
          <div className={styles.privacyNote}>
            <span className={styles.privacyIcon}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0110 0v4" />
              </svg>
            </span>
            <span className={styles.privacyText}>
              Your health data is safe with us and will never be shared.
            </span>
          </div>

          {/* CTA buttons */}
          <button className={`btn-primary `} onClick={onNext}>
            Start screening
          </button>
          <button className={styles.secondaryBtn}>
            I'll do it later
          </button>
        </div>

        {/* Right column — illustration */}
        <div className={styles.welcomeRight}>
          <div className={styles.illustrationWrap}>
            {/* Decorative blob */}
            <div className={styles.blob} />

            {/* Uterus icon circle */}
            <div className={styles.uterusCircle}>
              <svg width="52" height="52" viewBox="0 0 64 64" fill="none">
                {/* Simplified uterus illustration */}
                <ellipse cx="32" cy="30" rx="14" ry="16" fill="#EDE9FE" stroke="#7C3AED" strokeWidth="2" />
                <path d="M18 30 Q10 30 10 22 Q10 16 16 16" stroke="#7C3AED" strokeWidth="2" fill="none" strokeLinecap="round" />
                <path d="M46 30 Q54 30 54 22 Q54 16 48 16" stroke="#7C3AED" strokeWidth="2" fill="none" strokeLinecap="round" />
                <path d="M28 46 Q28 52 26 54" stroke="#7C3AED" strokeWidth="2" fill="none" strokeLinecap="round" />
                <path d="M36 46 Q36 52 38 54" stroke="#7C3AED" strokeWidth="2" fill="none" strokeLinecap="round" />
                <circle cx="32" cy="28" r="5" fill="#7C3AED" opacity="0.2" />
                <circle cx="32" cy="28" r="3" fill="#7C3AED" opacity="0.5" />
                {/* Decorative dots around */}
                <circle cx="14" cy="14" r="2" fill="#C4B5FD" />
                <circle cx="50" cy="14" r="2" fill="#C4B5FD" />
                <circle cx="8" cy="36" r="1.5" fill="#DDD6FE" />
                <circle cx="56" cy="36" r="1.5" fill="#DDD6FE" />
              </svg>
            </div>

            {/* Woman illustration (CSS-drawn) */}
            <div className={styles.womanFigure}>
              {/* Head */}
              <div className={styles.womanHead} />
              {/* Hair */}
              <div className={styles.womanHair} />
              {/* Body */}
              <div className={styles.womanBody} />
              {/* Legs crossed */}
              <div className={styles.womanLegs} />
            </div>

            {/* Decorative stars/sparkles */}
            <div className={styles.sparkle1}>✦</div>
            <div className={styles.sparkle2}>✦</div>
            <div className={styles.sparkle3}>·</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreenPCOS;